import { useState, useCallback } from "react"
import { useMounted } from "./mounted"

export function useMountedState(initialState) {
  const [value, _setValue] = useState(initialState)
  const mounted = useMounted()

  const setValue = useCallback(
    newValue => {
      mounted.current && _setValue(newValue)
    },
    [mounted],
  )

  return [value, setValue]
}
